import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Checkout_content from "../components/component-checkout";

function Checkout(){

    return(
        <>
            <ChangePageTitle pageTitle="تکمیل سفارش | رستوران باغبان" />
            <Checkout_content />
        </>
    );

}

export default Checkout;